import { NgModule } from '@angular/core';
import { FormChangesModule } from '@tcp13equals2/z5-lib';

import { CopyToClipboardDirective } from './copy-to-clipboard';
import { FormErrorMessageDirective } from './form-error-message';

const directives = [CopyToClipboardDirective, FormErrorMessageDirective];

@NgModule({
	imports: [FormChangesModule],
	exports: [...directives, FormChangesModule],
	declarations: [...directives],
	providers: []
})
export class DirectivesModule {}
